import { useEffect, useRef } from 'react';
import { useSocketStore } from '../lib/socket-state.ts';

export const useSocketRoom = (roomId, options = {}) => {
    const { joinRoom, leaveRoom, on, off, isConnected } = useSocketStore();
    const { onJoin, onLeave, events = {} } = options;
    const handlersRef = useRef({});

    useEffect(() => {
        if (!roomId || !isConnected) return;

        // Join the room when component mounts
        joinRoom(roomId);

        if (onJoin) {
            onJoin(roomId);
        }

        // Register event handlers for this room
        Object.entries(events).forEach(([eventName, handler]) => {
            handlersRef.current[eventName] = handler;
            on(eventName, handler);
        });

        // Cleanup: leave room when component unmounts
        return () => {
            leaveRoom(roomId);

            if (onLeave) {
                onLeave(roomId);
            }

            // Remove all event listeners
            Object.entries(handlersRef.current).forEach(([eventName, handler]) => {
                off(eventName, handler);
            });
            handlersRef.current = {};
        };
    }, [roomId, isConnected]);

    return { isConnected };
};